import React from 'react';
import { cx, focusRing, motion } from './classes';

/**
 * A pill for picking one option, such as an instrument in the Add clip picker. Put a row of them in a
 * <fieldset> with a <legend> that asks the question ("What instrument is this?").
 */
export const ChoiceChip = ({ selected = false, onSelect, className, children, ...rest }) => (
  <button
    type="button"
    aria-pressed={selected}
    onClick={onSelect}
    className={cx(
      'min-h-target-min px-space-4 rounded-radius-pill border font-text text-small transition-colors',
      selected
        ? 'bg-ink border-ink text-on-light font-bold'
        : 'bg-transparent border-control text-ink font-medium hover:bg-raised',
      motion,
      focusRing,
      className
    )}
    {...rest}
  >
    {children}
  </button>
);
